import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const MONITOR_SCREEN: AppRouteRecordRaw = {
  path: '/monitor-screen',
  name: 'MonitorScreenRoot',
  component: DEFAULT_LAYOUT,
  redirect: '/monitor-screen/index',
  meta: {
    locale: 'menu.dashboard.monitorScreen',
    icon: 'icon-desktop',
    requiresAuth: true,
    order: 4.5,
  },
  children: [
    {
      path: 'index',
      name: 'MonitorScreen',
      component: () => import('@/views/dashboard/monitor-screen/index.vue'),
      meta: { locale: 'menu.dashboard.monitorScreen', requiresAuth: true, roles: ['*'] },
    },
  ],
};

export default MONITOR_SCREEN;
